import { FC } from "react"
import { useTranslation } from "react-i18next"

import TextModal from "components/TextModal/TextModal"
import { RESERVATION_INVOICE_POSITION_TEXT_LINE_BREAK_AFTER } from "models/ReservationInvoicePosition"
import Button from "components/Button/Button"
import { Grid, GridItem } from "components/Grid"
import { TextVariable, TextVariableGroup } from "config/constants"
import { Flex } from "components/Flex"
import InsertTextVariableDropdown from "components/InsertTextVariableDropdown/InsertTextVariableDropdown"

interface IInvoicePositionTextModalProps {
    isAdd?: boolean
    text?: string
    setText?(text: string): void
    onInsertConfiguration?(): void
    onSave?(text: string): Promise<void> | void
    onClose(): void
    textVariableGroup?: TextVariableGroup
}

const InvoicePositionTextModal: FC<IInvoicePositionTextModalProps> = ({
    isAdd,
    text = "",
    setText,
    onInsertConfiguration,
    onSave,
    onClose,
    textVariableGroup = TextVariableGroup.withInvoiceCounter,
}) => {
    const { t } = useTranslation()

    const getDescription = ({ onInsertTextVariableClick }: { onInsertTextVariableClick?: (textVariable: TextVariable) => void } = {}) => (
        <Grid
            columns="minmax(0, auto) max-content"
            gap="3.2rem"
            alignItems="end"
            justifyContent="space-between">
            <GridItem>
                <div className="mb-2">{t("textModal.formattingRules")}</div>
                <div>{t("textModal.lineBreakAfter", { lineBreakAfter: RESERVATION_INVOICE_POSITION_TEXT_LINE_BREAK_AFTER })}</div>
            </GridItem>
            <Flex gap="1.6rem" justifyContent="end" alignItems="center">
                {!!onInsertTextVariableClick &&
                    <InsertTextVariableDropdown
                        onTextVariableSelect={onInsertTextVariableClick}
                        textVariableGroup={textVariableGroup}
                    />
                }
                {!!onInsertConfiguration && !!onSave &&
                    <Button
                        theme="link"
                        label={t("textModal.insertConfigurationText")}
                        onClick={onInsertConfiguration}
                    />
                }
            </Flex>
        </Grid>
    )

    return (
        <TextModal
            title={t(isAdd ? "textModal.addText" : (onSave ? "textModal.changeText" : "reservation.invoicePositionText"))}
            getDescription={getDescription}
            text={text}
            lineBreakAfter={RESERVATION_INVOICE_POSITION_TEXT_LINE_BREAK_AFTER}
            onChangeText={setText}
            onSave={onSave}
            onClose={onClose}
            textVariables
            monospace
        />
    )
}

export default InvoicePositionTextModal
